import { forwardRef } from "react";
import type { ISubItemsList } from "@app/dashboard/types/innerLayout/nav-item";
import SubItem from "../SubItem";
import styles from "../nav-item.module.scss";

const SubItemsList = forwardRef<HTMLDivElement, ISubItemsList>((
  { title, subItems, closeDropdown, onSubItemClick, collapsed, navItemId },
  ref
) => {
  return (
    <div className={styles["sub-items-list"]} ref={ref}>
      {
        title &&
        <div className={styles["sub-items-list__title"]}>
          {title}
        </div>
      }
      {
        subItems?.map((_, index: number) => {
          return (
            <SubItem
              key={index}
              subItems={subItems}
              index={index}
              navItemLabel={title as string}
              navItemId={navItemId}
              closeDropdown={closeDropdown}
              onSubItemClick={onSubItemClick}
              collapsed={collapsed}
            />
          )
        })
      }
    </div>
  )
});

export default SubItemsList;